<template>
  <form id="otpForm" @submit.prevent="validateBeforeSubmit">
    <div :class="{ 'form-group': true }">
      <p class="input-label">
        {{ $t("login.enter_otp") }} <span class="text-danger"> * </span>
      </p>
      <base-input
        :invalid="$v.otpData.code.$error"
        v-model="otpData.code"
        :placeholder="''"
        focus
        type="number"
        name="code"
        @input="$v.otpData.code.$touch()"
      />
      <input v-model="otpData.id" type="hidden" >

      <div v-if="$v.otpData.code.$error">
        <span v-if="!$v.otpData.code.required" class="text-danger">
          {{ $tc("validation.required") }}
        </span>
        <span v-if="!$v.otpData.code.minLength" class="text-danger">
          {{ $tc("validation.digits_otp") }}
        </span>
        <span v-if="!$v.otpData.code.maxLength" class="text-danger">
          {{ $tc("validation.digits_otp") }}
        </span>
      </div>
    </div>
    <div class="row">
      <base-button :loading="isLoading" type="submit" color="success">{{
        $t("login.submit_otp")
      }}</base-button>
      <base-button
        :loading="resendLoading"
        type="button"
        color="theme"
        style="marginLeft: 10px"
        @click="resend"
      >{{ $t("login.resend_otp") }}</base-button
      >
    </div>
    <div class="other-actions row">
      <div class="col-sm-12 text-sm-left mb-4">
        <p class="support-line">{{ $t("login.expiration_otp") }}</p>
        <p class="support-line">{{ $t("login.support_line") }}</p>
      </div>
    </div>
  </form>
</template>

<script type="text/babel">
import { validationMixin } from 'vuelidate'
import { mapActions } from 'vuex'

const { required, minLength, maxLength } = require('vuelidate/lib/validators')

export default {
  components: {},
  mixins: [validationMixin],
  data () {
    return {
      otpData: {
        code: '',
        id: ''
      },
      submitted: false,
      isLoading: false,
      resendLoading: false
    }
  },
  created () {
    this.otpData.id = this.$route.params.id
  },
  validations: {
    otpData: {
      code: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(6)
      }
    }
  },
  methods: {
    ...mapActions('auth', ['verifyOtp', 'resendOtp']),
    async validateBeforeSubmit () {
      this.$v.otpData.$touch()
      if (this.$v.$invalid) {
        return true
      }

      this.isLoading = true
      this.verifyOtp(this.otpData)
        .then((res) => {
          if (res.data.data.role === 'super_admin') {
            this.$router.push('/super-admin/dashboard')
          } else if (res.data.data.account_type == 'anchor') {
            this.$router.push('/anchor/dashboard')
          } else if (res.data.data.account_type == 'funder') {
            this.$router.push('/funder/dashboard')
          } else if (res.data.data.account_type == 'auditor') {
            this.$router.push('/auditor/islamic-finances')
          } else if (res.data.data.account_type == 'distributor') {
            this.$router.push('/distributor/dashboard')
          } else {
            this.$router.push('/supplier/dashboard')
          }
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    async resend () {
      this.resendLoading = true

      this.resendOtp(this.otpData).then((res) => {
        this.resendLoading = false
      }).catch()
    }
  }
}
</script>
